/*
  Anonymous Actions
*/
export const AUTHENTICATING_USER_REQUEST = 'AUTHENTICATING_USER_REQUEST';
export const AUTHENTICATING_USER_SUCCEDDED = 'AUTHENTICATING_USER_SUCCEDDED';
export const AUTHENTICATING_USER_FAILED = 'AUTHENTICATING_USER_FAILED';

export const USER_REGISTRATION_REQUEST = "USER_REGISTRATION_REQUEST";
export const USER_REGISTRATION_SUCCEDDED = "USER_REGISTRATION_SUCCEDDED";
export const USER_REGISTRATION_FAILED = "USER_REGISTRATION_FAILED";

export const FETCHING_USER_PROFILE = 'FETCHING_USER_PROFILE';
export const FETCHING_USER_PROFILE_SUCCEEDED = 'FETCHING_USER_PROFILE_SUCCEEDED';
export const FETCHING_USER_PROFILE_FAILED = 'FETCHING_USER_PROFILE_FAILED';

export const FETCHING_SSO_URL_REQUEST = 'FETCHING_SSO_URL_REQUEST';
export const FETCHING_SSO_URL_SUCCEEDED = 'FETCHING_SSO_URL_SUCCEEDED';
export const FETCHING_SSO_URL_FAILED = 'FETCHING_SSO_URL_FAILED';

export const SSO_AUTHENTICATION_FAILED = 'SSO_AUTHENTICATION_FAILED';
export const LOGOUT_USER_REQUEST = 'LOGOUT_USER_REQUEST';
export const LOGOUT_USER = 'LOGOUT_USER'; 

export const FETCHING_SHOWCASE = 'FETCHING_SHOWCASE'
export const FETCHING_SHOWCASE_SUCCEEDED = 'FETCHING_SHOWCASE_SUCCEEDED'
export const FETCHING_SHOWCASE_FAILED = 'FETCHING_SHOWCASE_FAILED'

export const UPDATE_VIEWS_REQUEST = 'UPDATE_VIEWS_REQUEST'
export const UPDATE_VIEWS_SUCCEEDED = 'UPDATE_VIEWS_SUCCEEDED'
export const UPDATE_VIEWS_FAILED = 'UPDATE_VIEWS_FAILED'

export const UPDATE_LIKES_REQUEST = 'UPDATE_LIKES_REQUEST'
export const UPDATE_LIKES_SUCCEEDED = 'UPDATE_LIKES_SUCCEEDED'
export const UPDATE_LIKES_FAILED = 'UPDATE_LIKES_FAILED'